import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PORTFOLIO } from "../lib/data";

export default function Portfolio() {
  return (
    <section id="work" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 items-end mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <span className="em-tag">02 — Selected Work</span>
            <h2
              className="mt-6 font-display font-extrabold tracking-tighter leading-[0.98]"
              style={{ fontSize: "clamp(2rem, 4.6vw, 4.4rem)" }}
            >
              A short list of very long nights.
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 text-white/70 leading-relaxed">
            Case studies from the last two years — music, product, culture. Always live, always high stakes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-14 md:gap-y-20">
          {PORTFOLIO.map((p, i) => (
            <motion.a
              key={p.title}
              href="#"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: (i % 2) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group block ${i % 2 === 1 ? "md:mt-16" : ""}`}
              data-testid={`portfolio-item-${i}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden border border-white/10">
                <img
                  src={p.img}
                  alt={p.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-700" />
              </div>

              <div className="mt-5 flex items-start justify-between gap-6">
                <div>
                  <div className="flex items-center gap-3 font-mono-em text-[0.68rem] tracking-[0.24em] uppercase text-white/50">
                    <span>Case · {p.year}</span>
                    <span className="h-px w-6 bg-white/20" />
                    <span>{p.kind}</span>
                  </div>
                  <h3
                    className="mt-3 font-display font-extrabold leading-[1.02] tracking-tight"
                    style={{ fontSize: "clamp(1.4rem, 2.2vw, 2rem)" }}
                  >
                    {p.title}
                  </h3>
                </div>
                <ArrowUpRight
                  size={22}
                  className="mt-1 opacity-40 transition-[transform,opacity] duration-500 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
